export default __webpack_public_path__ + "static/Air_Quality_and_Outdoor_Activity_Guidance-9609658fdf432b87f696a8d79ddcb316.pdf";